import React from "react";
import { useSelector } from "react-redux";


const NotFoundPage = () => {
  const settingsRes = useSelector((state) => state.settingsReducers.settings);
  return (
    <section className="page_404">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 ">
            <div
              className="col-sm-10 col-sm-offset-1 text-center"
              style={{ width: "100%" }}
            >
              <div className="four_zero_four_bg">
                <h1
                  className="text-center"
                  style={{ color: settingsRes?.data?.primaryColor }}
                >
                  404
                </h1>
              </div>

              <div className="contant_box_404">
                <h3
                  className="h2"
                  style={{ color: settingsRes?.data?.primaryColor }}
                >
                  Look like you're lost
                </h3>

                <p style={{ color: settingsRes?.data?.primaryColor }}>
                  the page you are looking for not avaible!
                </p>

                <a
                  href="/"
                  className="link_404"
                  style={{ backgroundColor: settingsRes?.data?.primaryColor }}
                >
                  Go to Home
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFoundPage;
